export default "__VITE_ASSET__ClURlv93__"